import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { AuthserviceService } from '../../../core/services/authservice.service';
import { LoginResponse } from '../../../core/models/users';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import { initFlowbite } from 'flowbite';
import { ChatUnreadSessionService } from '../../../core/services/chat-unread-session.service';
import { AdminCountersService, AdminCountersState } from '../../../core/services/admin-counters.service';

@Component({
    selector: 'app-sidenav',
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NgxSpinnerModule
    ],
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() collapsed = false;
  @Output() closed = new EventEmitter<void>();

  isDarkMode = false;

  openSections = {
    solicitudes: true,
    presupuestos: true,
  };

  toggleSection(section: keyof typeof this.openSections) {
    this.openSections[section] = !this.openSections[section];
  }

  isSectionOpen(section: keyof typeof this.openSections): boolean {
    return this.openSections[section];
  }

  User: LoginResponse | undefined;
  readonly spinnerName = 'sidenavSpinner';
  pendientesCount = 0;
  hayIncidenciasAbiertas = false;
  presupuestosPendientesCount = 0;
  hayPresupuestosIncidenciasAbiertas = false;
  chatUnreadCount = 0;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private authservice: AuthserviceService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private adminCounters: AdminCountersService,
    private chatUnreadSession: ChatUnreadSessionService
  ) {
    this.User = this.authservice.usuarioValue;
  }

  ngOnInit(): void {
    const stored = localStorage.getItem('dark-mode');
    this.isDarkMode = stored === 'true';
    this.updateBodyClass();
    this.adminCounters.state$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => this.aplicarContadores(state));
    this.adminCounters.refresh('sidenav-init');
    this.chatUnreadSession.unreadCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => this.chatUnreadCount = count);
  }

  ngAfterViewInit(): void {
    initFlowbite();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private aplicarContadores(state: AdminCountersState): void {
    this.pendientesCount = state.pendingRequests;
    this.hayIncidenciasAbiertas = state.requestIncidents > 0;
    this.presupuestosPendientesCount = state.pendingBudgets;
    this.hayPresupuestosIncidenciasAbiertas = state.budgetIncidents > 0;
  }

  navigateTo(route: string): void {
    this.spinner.show(this.spinnerName);
    this.router.navigate([route])
      .finally(() => this.spinner.hide(this.spinnerName));
  }

  isRouteActive(routePrefix: string): boolean {
    return this.router.url.startsWith(routePrefix);
  }

  closeSidenav(): void {
    this.closed.emit();
  }

  closeMobileSidenav(): void {
    if (typeof window === 'undefined') return;
    if (!window.matchMedia('(max-width: 900px)').matches) return;
    this.closeSidenav();
  }

  logout() {
    this.spinner.show(this.spinnerName);
    this.authservice.logout();
    setTimeout(() => this.spinner.hide(this.spinnerName), 1500);
  }

  onDarkModeChange(value: boolean) {
    this.isDarkMode = value;
    localStorage.setItem('dark-mode', String(value));
    this.updateBodyClass();
  }

  private updateBodyClass() {
    if (this.isDarkMode) {
      this.renderer.addClass(document.body, 'dark');
    } else {
      this.renderer.removeClass(document.body, 'dark');
    }
  }

}

